var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconType4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#905BE6",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9228 8.24935L8.52246 17.5166C8.08089 17.7389 8.06921 18.3682 8.50455 18.6057L14.5821 21.9216L19.7271 16.0829C19.9513 15.8277 20.3398 15.8024 20.595 16.0265C20.8503 16.2506 20.8755 16.6392 20.6514 16.8944L15.6892 22.5257L22.0434 25.9926C22.3877 26.1805 22.8183 26.0019 22.9283 25.6251L27.7898 8.97093C27.9401 8.4561 27.4022 8.00789 26.9228 8.24935Z",
    fill: "#905BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9482 23.5225V27.2033C14.9482 27.8179 15.755 28.0509 16.0831 27.532L17.6767 25.0112L14.9482 23.5225Z",
    fill: "#905BE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6364,
    height: 19.6364,
    fill: "white",
    transform: "translate(8.18164 8.18188)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconType4);
export default __webpack_public_path__ + "static/media/icon-type-4.6f690a23.svg";
export { ForwardRef as ReactComponent };